import React, { memo } from 'react';
import { ImageNotSupported } from '@mui/icons-material';
import { Box } from '@mui/material';
import { useFirebaseImageFromUrl } from '../../firebase';

interface ImageSimpleColumnProps {
  onClick?: () => void;
  url?: string;
}

const ImageSimpleColumnComponent = ({
  url,
  onClick,
}: ImageSimpleColumnProps) => {
  const { data: imageUrl, isLoading } = useFirebaseImageFromUrl(url);
  if (!url) return null;

  if (isLoading) {
    return (
      <div
        style={{
          width: 48,
          height: 48,
          borderRadius: 6,
          background: '#e0e0e0',
        }}
      />
    );
  }

  return (
    <img
      src={imageUrl ?? '/placeholder.png'}
      onClick={onClick}
      style={{
        width: 48,
        height: 48,
        borderRadius: 6,
        objectFit: 'cover',
        cursor: 'pointer',
      }}
      alt="recognition"
    />
  );
};

export default memo(ImageSimpleColumnComponent);
